export const actionKey = '@@MODERATION';
export const reduxKey = '@@MODERATION';
